///? Default IMPORTS

import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

///? Service IMPORTS

import {
  pickerOrderDetailsThunk,
  saveMissingMedicineDetails,
  // clearPickerDetails,
} from "../../../redux/PickerOrder/Action";
import { updatePackageStatusThunk } from "../../../redux/packageTrackerRedux/Action";

import {
  getScannedPickerOrderDetailsThunk,
  savePickerMissingMedicineDetails,
  clearPickerDetails,
} from "../../../redux/NewPickerRedux/Action";

import { addToPickerLog } from "../../../redux/MedicineLog/action";

import { getMedDetailsThunk } from "../../../redux/newCheckerRedux/Action";

///? Component & Styling IMPORTS

import {
  Button,
  Checkbox,
  Divider,
  Empty,
  message,
  Modal,
  Result,
  Select,
  Spin,
  Switch,
  Table,
  Tag,
} from "antd";
import BarcodeScanner from "../../../components/BarcodeScanner/BarcodeScanner";
import { Base64func } from "../../../components/Base64Func/Base64func";
import OrderDetails from "../../../components/OrderDetailSection/OrderDetails";
import { AiOutlineScan } from "react-icons/ai";
import { ROLES, warehouseId } from "../../../constants/index";
import { PACKAGE_STATUS } from "../../../constants/index";
import IncrementDecrementInput from "../../../components/IncrementDecrementInput/IncrementDecrementInput";
import { RiErrorWarningLine } from "react-icons/ri";
import { GiThermometerCold } from "react-icons/gi";
import {
  FooterButtons,
  MedBoxModalPicker,
  MedBoxPicker,
  MedIssueModalWrapperPicker,
  RackLocation,
} from "./PickerOrderPage.styled";
import MedicineLog from "../../../components/MedicineLog/MedicineLog";
import moment from "moment";
import { getOrderItembatchesFromNetsuitThunk } from "../../../redux/newCheckerRedux/Action";
import { CloseCircleOutlined } from "@ant-design/icons";
///? Constants

const { Option } = Select;
message.config({
  maxCount: 1,
});

export class PickerOrderPage extends Component {
  state = {
    currentOrderData: null,
    currentOrderId: null,
    currentBoxId: null,
    showScannerScreen: false,
    medData: [],
    updatedMedData: [],
    notSelectedMed: null,
    selectedMed: null,
    missingMedData: null,
    medIssueModal: false,
    // batchesToSend: [],
    // batchesToSendId: [],
    currentSelectReason: null,
    isFinalScreen: false,
    errorFinalScreen: false,
    showMedTable: false,
    isConfirmSubmit: false,
    pickerFlow: null,
    medReasonData: null,
    normalFlowReasons: null,
    missingFlowReasons: null,
    selectedIssueMed: [],
    coldChainConfirmModal: false,
    serviceLoading: false,
    remainingQty: 0,
    boxUpdate: false,
    color: null,
    text: "",
    batches: null,
    rackLocation: null,
  };
  componentDidMount() {
    //? Getting order ID from url

    let currPath = window.location.href;

    let currPathArr = currPath.split("/");

    let orderValue = "";
    // let boxValue = "";

    currPathArr.map((item) =>
      item.includes("orderId") ? (orderValue = item.split("=")[1]) : ""
    );

    // currPathArr.map((item) =>
    //   item.includes("boxId") ? (boxValue = item.split("=")[1]) : ""
    // );

    this.setState(
      {
        currentOrderId: Base64func(orderValue, "decode"),
        serviceLoading: true,
        // currentBoxId: Base64func(boxValue, "decode"),
      },
      () => {
        const storedSelectedOption =
          JSON.parse(localStorage.getItem("pickerFlow")) || false;
        this.setState({ pickerFlow: storedSelectedOption });
        this.fetchBatchOrderItems();
      }
    );
  }
  // Selecting batches on the basis of ns_Item_id)
  preSelectBatches = (allBatches, med) => {
    let selectedBatches = [];
    let temp = [];
    let isProductBlocked = false;
    if (allBatches?.length > 0) {
      for (let i in allBatches) {
        let batch = allBatches[i];
        if (Number(batch.ns_item_id) === Number(med.nsItemId)) {
          temp = batch.batches;
          isProductBlocked = batch.isProductBlocked
            ? batch.isProductBlocked
            : false;
          break;
        }
      }
      if (temp?.length > 0) {
        for (let i in temp) {
          let tempObj = {};
          let batch = temp[i];
          tempObj.batchNumber = batch.batch_number;
          tempObj.expiryNearBy = batch.expiryNearBy;
          tempObj.expiryDate = batch.expiry_date;
          tempObj.isBatchBlocked = batch.isBatchBlocked
            ? batch.isBatchBlocked
            : false;
          tempObj.isProductBlocked = isProductBlocked;
          tempObj.maxQty = Number(batch.quantity);
          tempObj.mrp = batch.mrp;
          tempObj.rate = batch.rate;
          tempObj.manufacturer_date = batch.manufacturer_date;
          tempObj.external_batch_number = batch.external_batch_number;
          tempObj.finalSubsId = this.setfinalSubsIdSet(
            this.state.allMedDetails,
            med.subsProductCd
          );
          tempObj.ns_item_id = med.nsItemId;
          selectedBatches.push(tempObj);
        }
      }
      // if (selectedBatches?.length > 0) {
      //   selectedBatches = selectedBatches.sort((a, b) => b.maxQty - a.maxQty);
      // }
    }
    return selectedBatches;
  };

  checkIfMedIsMissing = (arr, productCode) => {
    let isMissing = false;
    for (let i in arr) {
      let med = arr[i];
      if (med.productCode === productCode) {
        isMissing = true;
        break;
      }
    }
    return isMissing;
  };

  setMissingQty = (arr, productCode) => {
    let qtyData = [];
    for (let i in arr) {
      let med = arr[i];
      let temp = {};
      if (med.productCode === productCode) {
        temp.qty = 0;
        temp.reasonId = 76;
        temp.id = med.id;
        temp.isPickSelect = true;
        qtyData.push(temp);
      }
    }
    return qtyData;
  };

  setQtyLevelData = () => {
    let qtyData = {};
    qtyData.qty = 0;
    qtyData.reasonId = null;
    return qtyData;
  };

  changeBoxModal = (value) => {
    this.setState({ boxUpdate: false }, () => {
      this.setState({ showScannerScreen: value });
    });
  };

  updateBoxId = (value) => {
    if (value) {
      this.setState({ currentBoxId: value });
    }
    this.setState({ showScannerScreen: false });
  };
  setfinalSubsIdSet = (arr, code) => {
    let id = null;
    for (let i in arr) {
      let med = arr[i];
      if (med.subsProductCd === code && med.medActive) {
        id = med.finalSubsId;
        break;
      }
    }
    return id;
  };

  setRackLocation = (sMed) => {
    let rackLocation = null;
    for (let i in this.state.allMedDetails) {
      let obj = this.state.allMedDetails[i];
      if (
        obj.medActive &&
        sMed &&
        (obj.subsProductCd
          ? sMed.productCode === obj.subsProductCd
          : sMed.productCode === obj.orgProductCd) &&
        obj.rackLocation &&
        (obj.rackLocation.bulkLocation || obj.rackLocation.jitLocation)
      ) {
        rackLocation = obj.rackLocation;
      }
    }
    return rackLocation;
  };
  getMedDetails() {
    this.props
      .getMedDetailsThunk({
        access_token: this.props.access_token,
        orderId: this.state.currentOrderId,
        history: this.props.history,
        isPickerRequest: true,
      })
      .then(() => {
        this.setState(
          {
            allMedDetails: this.props.checkerDetails.allMedDetails
              ?.productSubsMappingList,
          },
          () => {
            let data = {
              orderId: this.state.currentOrderId,
              warehouseId: warehouseId,
              access_token: this.props.access_token,
              history: this.props.history,
            };

            this.props.getScannedPickerOrderDetailsThunk(data).then(() => {
              this.setState(
                {
                  currentOrderData: this.props.newPickerDetails
                    .newScannedPickerOrderDetailsSuccess,
                },
                () => {
                  if (
                    this.props.newPickerDetails
                      ?.newScannedPickerOrderDetailsSuccess
                  ) {
                    let productCodeList = [];

                    let productCodeListMed = [];

                    let missingMedicineDetails = [];

                    let isMissingFlow = false;
                    if (
                      this.props.newPickerDetails
                        ?.newScannedPickerOrderDetailsSuccess
                        ?.missingMedicineDetails?.length > 0
                    ) {
                      this.state.allMedDetails?.map((e) => {
                        if (
                          e.medActive &&
                          this.checkIfMedIsMissing(
                            this.props.newPickerDetails
                              ?.newScannedPickerOrderDetailsSuccess
                              ?.missingMedicineDetails,
                            e.subsProductCd
                          ) &&
                          !productCodeListMed.includes(e.subsProductCd)
                        ) {
                          productCodeListMed.push(e.subsProductCd);

                          let medicineDetails = {};
                          medicineDetails.name = e.subsMedName;
                          medicineDetails.medIssue = false;
                          medicineDetails.productCode = e.subsProductCd;
                          medicineDetails.orderId = this.state.currentOrderId;
                          medicineDetails.qty = e.subsQuantity;
                          medicineDetails.qtyData = this.setMissingQty(
                            this.props.newPickerDetails
                              ?.newScannedPickerOrderDetailsSuccess
                              ?.missingMedicineDetails,
                            e.subsProductCd
                          );
                          medicineDetails.active = false;

                          missingMedicineDetails.push(medicineDetails);

                          isMissingFlow = true;
                        }
                      });
                    }

                    let medicineList = [];
                    this.state.allMedDetails?.map((e) => {
                      if (
                        e.medActive &&
                        !productCodeList.includes(e.subsProductCd)
                      ) {
                        productCodeList.push(e.subsProductCd);
                        let medicineDetails = {};
                        medicineDetails.name = e.subsMedName;
                        medicineDetails.medIssue = false;
                        medicineDetails.productCode = e.subsProductCd;
                        medicineDetails.orderId = this.state.currentOrderId;
                        medicineDetails.qty = e.subsQuantity;
                        medicineDetails.qtyData = [this.setQtyLevelData()];
                        medicineDetails.batches = this.preSelectBatches(
                          this.state.batches?.order_itembatches,
                          e
                        );
                        medicineList.push(medicineDetails);
                      }
                    });

                    //? Sorting MedicineData
                    if (
                      JSON.parse(localStorage.getItem("pickerFlow")) === true
                    ) {
                      medicineList = medicineList.sort((a, b) =>
                        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
                      );
                      missingMedicineDetails = missingMedicineDetails.sort(
                        (a, b) =>
                          a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
                      );
                    } else if (
                      JSON.parse(localStorage.getItem("pickerFlow")) === false
                    ) {
                      medicineList = medicineList.sort((a, b) =>
                        a.name.toLowerCase() < b.name.toLowerCase() ? 1 : -1
                      );
                      missingMedicineDetails = missingMedicineDetails.sort(
                        (a, b) =>
                          a.name.toLowerCase() < b.name.toLowerCase() ? 1 : -1
                      );
                    }
                    this.setState(
                      {
                        medData: isMissingFlow
                          ? missingMedicineDetails
                          : medicineList,
                        notSelectedMed: isMissingFlow
                          ? missingMedicineDetails
                          : medicineList,
                        missingMedData: missingMedicineDetails,
                        serviceLoading: false,
                      },
                      () => {
                        this.setState(
                          {
                            selectedMed: this.state.medData[0],
                            currentBoxId: this.state.currentOrderData.boxNumber,
                            medReasonData: this.state.currentOrderData.reasonMasterList.filter(
                              (i) => i.name === "PICKER_REASON" && i.active
                            ),
                          },
                          () => {
                            this.setState({
                              rackLocation: this.setRackLocation(
                                this.state.selectedMed
                              ),
                              remainingQty: this.state.selectedMed?.qty,
                              normalFlowReasons: this.state.medReasonData.filter(
                                (i) =>
                                  i.value !== "Picked" &&
                                  i.value !== "Cold Chain"
                              ),
                              missingFlowReasons: this.state.medReasonData.filter(
                                (i) => i.active && i.value !== "Cold Chain"
                              ),
                            });
                          }
                        );
                      }
                    );
                    this.tagger();
                  } else if (
                    this.props.newPickerDetails?.newScannedPickerOrderError
                  ) {
                    message.error(
                      this.props.newPickerDetails?.newScannedPickerOrderError
                    );
                    this.setState({ serviceLoading: false });
                  }
                }
              );
            });
          }
        );
      });
  }

  fetchBatchOrderItems() {
    this.setState({
      serviceLoading: true,
    });
    this.props
      .getOrderItembatchesFromNetsuitThunk({
        access_token: this.props.access_token,
        orderId: this.state.currentOrderId,
      })
      .then(() => {
        if (this.props.checkerDetails.allBatchDetailsError) {
          message.error(this.props.checkerDetails.allBatchDetailsError);
          this.getMedDetails();
        } else if (this.props.checkerDetails.allBatchDetails) {
          this.setState(
            {
              batches: this.props.checkerDetails.allBatchDetails,
            },
            () => this.getMedDetails()
          );
        } else {
          message.error("Something went wrong!");
          this.getMedDetails();
        }
      });
  }

  handleBatchEdit(value, pos) {
    // let { batchesToSend, batchesToSendId } = this.state;
    let medicineList = this.state.selectedMed;
    if (
      this.state.remainingQty === 0 &&
      value > medicineList.qtyData[pos]["qty"]
    ) {
      message.error("Max Limit reached");
    } else {
      medicineList.qtyData[pos]["qty"] = value;

      // let tempBatchArray = batchesToSend;

      // if (
      //   batchesToSendId.includes(medicineList.qtyData[pos].invoiceBatchtId)
      // ) {
      //   batchesToSend[
      //     batchesToSendId.indexOf(medicineList.qtyData[pos].invoiceBatchtId)
      //   ] = medicineList.qtyData[pos];
      // } else {
      //   batchesToSend.push(medicineList.qtyData[pos]);
      //   batchesToSendId.push(medicineList.qtyData[pos].invoiceBatchtId);
      // }

      let sQty = 0;

      for (let i in medicineList?.qtyData) {
        let med = medicineList?.qtyData[i];
        if (med.qty > 0) {
          sQty = sQty + med.qty;
        }
      }

      let rQty = this.state.selectedMed?.qty - sQty;
      this.setState({
        // batchesToSendId: batchesToSendId,
        // batchesToSend: tempBatchArray,
        selectedMed: medicineList,
        rackLocation: this.setRackLocation(medicineList),
        remainingQty: rQty,
      });
    }
  }

  handleReasonChange = (value, pos) => {
    let currentUpdateMed = this.state.selectedMed;

    let pickedReason = this.state.medReasonData.find(
      (i) => i.value === "Picked"
    );

    let pickedKey = pickedReason.reasonId;

    //? For Missing flow selecting Checker reason & Setting picker reason
    currentUpdateMed.qtyData[pos]["reasonId"] = value;
    currentUpdateMed.qtyData[pos]["active"] = true;

    if (pickedKey !== value) {
      currentUpdateMed["medIssue"] = true;
      currentUpdateMed.qtyData[pos]["isPickSelect"] = false;
    } else {
      currentUpdateMed["medIssue"] = false;
      currentUpdateMed.qtyData[pos]["isPickSelect"] = true;
    }

    this.setState({
      selectedMed: currentUpdateMed,
      rackLocation: this.setRackLocation(currentUpdateMed),
    });
  };

  //? coldchain function here
  markOrderColdChain = () => {
    message.loading("Please wait...", 0);

    let { selectedMed } = this.state;

    let coldChainReason = this.state.medReasonData.find(
      (i) => i.value === "Cold Chain"
    );

    if (selectedMed?.productCode) {
      let dataList = [];

      selectedMed?.qtyData?.map((e) => {
        let temp = {};
        temp.name = this.state.selectedMed?.name;
        temp.productCode = this.state.selectedMed?.productCode;
        temp.quantity = e.id ? e.qty : this.state.selectedMed?.qty;
        // temp.batchNumber = e.batchNumber;
        temp.orderId = this.state.selectedMed?.orderId;
        temp.active = true;
        // temp.invoiceBatchtId = e.invoiceBatchtId;
        temp.reasonId = coldChainReason.reasonId;
        temp.warehouseId = warehouseId;

        if (e.id) {
          temp.id = e.id;
        }
        dataList.push(temp);
      });

      let data = {};
      data.missingMedicineDetailsList = dataList;
      data.access_token = this.props.access_token;

      if (
        selectedMed.name ===
        this.state.medData[this.state.medData.length - 1].name
      ) {
        data.lastMed = true;
        // message.success("Heyyy", 0);
      }
      this.props.savePickerMissingMedicineDetails(data).then(() => {
        if (this.props.newPickerDetails.missingMeds) {
          message.success(this.props.newPickerDetails.missingMeds?.OK);
          //? Cold chain service call here
          this.coldChainServiceCall();
        } else if (this.props.newPickerDetails.missingMedsError) {
          message.error(this.props.newPickerDetails.missingMedsError, 1);
        } else {
          message.error("Something went wrong.", 1);
        }
      });
    }
  };

  coldChainServiceCall = () => {
    message.loading("Please wait...", 0);

    let payload = {
      packageStatusId: 182,
      awbNoPrinted: false,
      orderId: this.state.currentOrderId,
      // boxSource: "ADMIN_PACKAGE_TRACKER",
      history: this.props.history,
    };
    this.props
      .updatePackageStatusThunk(payload, this.props.access_token)
      .then(() => {
        if (this.props.pdf?.updatePackageSuccess) {
          message.success(this.props.pdf?.updatePackageSuccess?.OK, 2);
          localStorage.setItem(
            "pickerFlow",
            JSON.stringify(!this.state.pickerFlow)
          );
          setTimeout(() => {
            message.destroy();
            this.props.history.push("/picker");
          }, 2000);
        } else {
          message.error(this.props.pdf?.updatePackageError, 2);
        }
      });
  };

  //? Missing Med function here
  saveMissingMeds = () => {
    let { selectedMed } = this.state;
    let findZero = 0;
    let medIssue = false;
    let index = null;

    let pickedReason = this.state.medReasonData.find(
      (i) => i.value === "Picked"
    );

    if (selectedMed?.qtyData?.length > 0) {
      let dataList = [];
      selectedMed.qtyData.map((e) => {
        if (!e.id && e.qty === 0) {
          findZero++;
        }

        if ((e.isPickSelect && e.qty === 0) || !e.isPickSelect) {
          let temp = {};
          temp.name = this.state.selectedMed?.name;
          temp.productCode = this.state.selectedMed?.productCode;
          temp.quantity = e.qty;
          // temp.batchNumber = e.batchNumber;
          temp.orderId = this.state.selectedMed?.orderId;
          temp.active = true;
          // temp.invoiceBatchtId = e.invoiceBatchtId;
          temp.reasonId = e.reasonId ? e.reasonId : pickedReason.reasonId;
          temp.warehouseId = warehouseId;

          if (e.id) {
            temp.id = e.id;
          }

          if (e.qty === 0) {
            temp.active = false;
          }

          //? Setting up medIssue key for updateMeddata
          index = this.state.medData.findIndex(
            (i) => i.name === this.state.selectedMed?.name
          );

          dataList.push(temp);
        } else {
          medIssue = true;
        }
      });

      if (findZero > 0) {
        message.error("Quantity 0 found. Please add quantity");
        return;
      }

      if (medIssue) {
        message.warning("Picked Selected, Quantity must be 0");
        return;
      }

      let data = {};
      data.missingMedicineDetailsList = dataList;
      data.access_token = this.props.access_token;

      if (
        selectedMed.name ===
        this.state.medData[this.state.medData.length - 1].name
      ) {
        data.lastMed = true;
      }

      this.props.savePickerMissingMedicineDetails(data).then(() => {
        if (this.props.newPickerDetails.missingMeds) {
          message.success(this.props.newPickerDetails.missingMeds?.OK);

          //? Setting up medIssue key for updateMeddata
          if (
            this.props.newPickerDetails.missingMeds?.["Picker Medicine Missing"]
          ) {
            // alert("Missing marked");
            let updateMedIssue = this.state.medData;
            if (index >= 0) {
              updateMedIssue[index]["medIssue"] = true;
              this.setState({
                medData: updateMedIssue,
              });
            }
          } else if (this.props.newPickerDetails.missingMeds?.["Picked"]) {
            let updateMedIssue = this.state.medData;
            updateMedIssue[index]["medIssue"] = false;
            this.setState({
              medData: updateMedIssue,
            });
          }

          // this.setState({
          //   batchesToSendId: [],
          //   batchesToSend: [],
          // });
          this.setState({ medIssueModal: false });
          this.pageChangeFunction();
        } else if (this.props.newPickerDetails.missingMedsError) {
          message.error(this.props.newPickerDetails.missingMedsError, 1);
        } else {
          message.error("Something went wrong.", 1);
        }
      });
    } else {
      this.setState({ medIssueModal: false });
      message.error("Looks like you haven't edited anything yet!", 1);
    }
  };

  //? Pick Medicine Service call

  handlePicked = () => {
    if (
      this.state.missingMedData.length === 0 ||
      this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess
        ?.packageStatus !== PACKAGE_STATUS.PICKED
    ) {
      message.loading("Please wait...", 0);

      let { selectedMed } = this.state;

      let updateMedIssue = this.state.selectedMed;
      updateMedIssue["medIssue"] = false;
      this.setState({
        selectedMed: updateMedIssue,
        rackLocation: this.setRackLocation(updateMedIssue),
      });

      let pickedReason = this.state.medReasonData.find(
        (i) => i.value === "Picked"
      );

      if (selectedMed?.productCode) {
        let dataList = [];

        selectedMed?.qtyData?.map((e) => {
          let temp = {};
          temp.name = this.state.selectedMed?.name;
          temp.productCode = this.state.selectedMed?.productCode;
          temp.quantity = e.id ? e.qty : this.state.selectedMed?.qty;
          // temp.batchNumber = e.batchNumber;
          temp.orderId = this.state.selectedMed?.orderId;
          temp.active = false;
          // temp.invoiceBatchtId = e.invoiceBatchtId;
          temp.reasonId = pickedReason.reasonId;
          temp.warehouseId = warehouseId;
          if (e.id) {
            temp.id = e.id;
          }
          dataList.push(temp);
        });

        let data = {};
        data.missingMedicineDetailsList = dataList;
        data.access_token = this.props.access_token;
        if (
          selectedMed.name ===
          this.state.medData[this.state.medData.length - 1].name
        ) {
          data.lastMed = true;
        }

        this.props.savePickerMissingMedicineDetails(data).then(() => {
          if (this.props.newPickerDetails.missingMeds) {
            message.success(this.props.newPickerDetails.missingMeds?.OK);
            this.props.addToPickerLog({
              pickerLog: this.props.pickerLog,
              newOrder: selectedMed,
            });
            this.pageChangeFunction();
          } else if (this.props.newPickerDetails.missingMedsError) {
            message.error(this.props.newPickerDetails.missingMedsError, 1);
          } else {
            message.error("Something went wrong.", 1);
          }
        });
      } else {
        message.error("No Medicine found");
      }
    }
  };

  //? Switch next screen function
  pageChangeFunction = () => {
    let notSelected = this.state.notSelectedMed.filter(
      (item) => item.name !== this.state.selectedMed.name
    );

    this.state.updatedMedData.push(this.state.selectedMed);

    this.setState(
      { notSelectedMed: notSelected, currentSelectReason: null },
      () => {
        this.setState({ selectedMed: this.state.notSelectedMed[0] }, () => {
          this.setState({
            remainingQty: this.state.selectedMed?.remainingQty,
            rackLocation: this.setRackLocation(this.state.selectedMed),
          });
        });

        if (this.state.updatedMedData.length === this.state.medData.length) {
          if (this.state.updatedMedData.some((item) => item.medIssue)) {
            this.setState({ isFinalScreen: true, errorFinalScreen: true });
          } else {
            this.setState({ isFinalScreen: true });
          }
        }
      }
    );
  };

  rackFunction = () => {
    //? Rack function here

    this.setState({ showScannerScreen: true });
  };

  finalPickerSubmit = () => {
    // message.loading("Submitting...", 0);
    // localStorage.setItem("pickerFlow", JSON.stringify(!this.state.pickerFlow));

    // setTimeout(() => {
    //   this.props.history.push("/picker");
    //   message.destroy();
    // }, 2000);
    this.props.history.push("/picker");
  };

  addNewReason = () => {
    let sMed = this.state.selectedMed;
    let data = this.setQtyLevelData();
    sMed?.qtyData?.push(data);
    this.setState({
      selectedMed: sMed,
      rackLocation: this.setRackLocation(sMed),
    });
  };

  checkForQty = (meds) => {
    let isQty = false;
    for (let i in meds?.qtyData) {
      let med = meds?.qtyData[i];
      if (med.qty > 0 && med.reasonId) {
        isQty = true;
      }
    }
    return isQty;
  };
  tagger = () => {
    let todayTimeStamp = Date.now();
    if (this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess.sdd) {
      this.setState({
        color: "green",
        text: "Hyperlocal",
      });
    } else {
      if (
        moment(
          this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess
            .orderDate
        ).format("DD-MM-YYYY") === moment(todayTimeStamp).format("DD-MM-YYYY")
      ) {
        this.setState({
          color: "yellow",
          text: "Today's Order",
        });
      } else {
        this.setState({
          color: "red",
          text: "Previous Day's Order",
        });
      }
    }
  };
  render() {
    window.addEventListener("beforeunload", function (e) {
      // Cancel the event
      e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
      // Chrome requires returnValue to be set
      e.returnValue = "";
    });

    const columns = [
      {
        title: "Medicine Name",
        dataIndex: "name",
        key: "name",
        render: (text) => {
          return {
            children: (
              <span style={{ color: "#000", fontWeight: 600 }}>{text}</span>
            ),
          };
        },
      },
    ];

    if (this.state.isFinalScreen) {
      return this.state.errorFinalScreen ? (
        /////////////////////////////////////////////////
        //? Final error picked Screen
        /////////////////////////////////////////////////

        <div className="centerScreen">
          <Result
            status="warning"
            title="Order issue found"
            subTitle="Please, Go to “Missing Zone”, find an empty rack and scan barcode to place your box."
            extra={
              <button className="bbtn" onClick={() => this.rackFunction()}>
                <AiOutlineScan /> Scan the barcode
              </button>
            }
          />

          {this.state.showScannerScreen && (
            <BarcodeScanner
              scan={this.state.showScannerScreen ? true : false}
              camera={this.state.showScannerScreen ? true : false}
              orderId={this.state.currentOrderId}
              history={this.props.history}
              currentBoxId={this.state.currentBoxId}
              // redirectMissing="MissingZone"
              redirect={"missing"}
              getBoxId={this.updateBoxId}
            />
          )}
        </div>
      ) : (
        /////////////////////////////////////////////////
        //? Final success picked Screen
        /////////////////////////////////////////////////

        <div className="centerScreen">
          <Result
            status="success"
            title="All medicines are picked"
            subTitle="Please click submit button below and put your medicine box on table for checkers."
            extra={
              <Button
                type="link"
                key="console"
                onClick={() =>
                  this.setState({ showMedTable: !this.state.showMedTable })
                }
              >
                {`${this.state.showMedTable ? "Hide" : "Show"} order summary`}
              </Button>
            }
          />

          {this.state.showMedTable && (
            <Table
              dataSource={this.state.updatedMedData}
              columns={columns}
              bordered
              pagination={this.state.updatedMedData.length > 10}
            />
          )}

          <FooterButtons>
            <button
              className="bbtn"
              disabled={this.props.isLoading}
              onClick={() => this.finalPickerSubmit()}
            >
              Go to home
            </button>
          </FooterButtons>

          {/* <Modal
            title="Confirm Picked?"
            visible={this.state.isConfirmSubmit}
            onOk={() => this.handlePicked()}
            centered
            onCancel={() => this.setState({ isConfirmSubmit: false })}
          /> */}
        </div>
      );
    } else {
      /////////////////////////////////////////////////
      //? Medicine Picking Screen Screen
      /////////////////////////////////////////////////

      return (
        <div className="centerScreen">
          <div
            className=""
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            {/* <Tag className="boxSection" color={this.state.color}>
              <span>{this.state.text}</span>
            </Tag> */}
          </div>
          <OrderDetails
            orderId={this.state.currentOrderId}
            customerName={this.state.currentOrderData?.customerName}
            invoiceDate={this.state.currentOrderData?.invoiceDate}
            paymentType={this.state.currentOrderData?.paymentType}
            orderValue={this.state.currentOrderData?.orderValue}
            boxId={this.state.currentBoxId}
            tagColor={this.state.color}
            tagText={this.state.text}
            updateBox={this.changeBoxModal}
            isLoading={this.state.serviceLoading}
          />

          {this.state.showScannerScreen && (
            <BarcodeScanner
              scan={this.state.showScannerScreen ? true : false}
              camera={this.state.showScannerScreen ? true : false}
              orderId={this.state.currentOrderId}
              history={this.props.history}
              getBoxId={this.updateBoxId}
              boxUpdate={this.state.boxUpdate}
            />
          )}
          <Spin spinning={this.state.serviceLoading}>
            <MedicineLog type={1} />
            <Divider>Medicine Details</Divider>

            {this.state.selectedMed ? (
              <>
                <MedBoxPicker>
                  <div className="medName">{this.state.selectedMed?.name}</div>
                  <p className="title">QTY</p>
                  <p className="title">{this.state.selectedMed?.qty}</p>
                </MedBoxPicker>
                {this.state.rackLocation ? (
                  <RackLocation
                    bothLocationAvailable={
                      this.state.rackLocation?.jitLocation &&
                      this.state.rackLocation?.bulkLocation
                        ? true
                        : false
                    }
                  >
                    {this.state.rackLocation.jitLocation ? (
                      <div>
                        <p>JIT Location:</p>
                        <p>{this.state.rackLocation?.jitLocation}</p>
                      </div>
                    ) : null}
                    {this.state.rackLocation.bulkLocation ? (
                      <div>
                        <p>Bulk Location:</p>
                        <p>{this.state.rackLocation?.bulkLocation}</p>
                      </div>
                    ) : null}
                  </RackLocation>
                ) : null}
              </>
            ) : (
              <Empty
                style={{ margin: "10vh 0" }}
                description="No Medicine found"
              />
            )}
            {this.state.selectedMed?.batches &&
            this.state.selectedMed.batches.length > 0 ? (
              <MedBoxPicker>
                <div
                  className={`batchDetails ${
                    this.state.selectedMed?.batches.filter(
                      (k) => k.isProductBlocked
                    )?.length > 0
                      ? "blocked"
                      : ""
                  }`}
                >
                  {this.state.selectedMed?.name}

                  {this.state.selectedMed?.batches.filter(
                    (k) => k.isProductBlocked
                  )?.length > 0 ? (
                    <Tag icon={<CloseCircleOutlined color="error" />}>
                      Medicine blocked!
                    </Tag>
                  ) : null}
                </div>
                <p className="title">Batch Number</p>
                <p className="title">Quantity</p>
                {/* first check weather any nearbyExp date flag is true then remove that from list then sort according to nearest expiry date */}
                {this.state.selectedMed?.batches
                  ?.filter((el) => !el?.expiryNearBy)
                  // .sort(
                  //   (a, b) => new Date(a.expiryDate) - new Date(b.expiryDate)
                  // )
                  ?.map((item, pos) => {
                    return (
                      <div
                        className={`batchList ${
                          item?.isBatchBlocked || item.isProductBlocked
                            ? "blocked"
                            : ""
                        }`}
                        key={pos}
                      >
                        <p>
                          {item?.batchNumber}
                          {item?.isBatchBlocked ? (
                            <Tag icon={<CloseCircleOutlined color="error" />}>
                              Batch blocked!
                            </Tag>
                          ) : null}
                        </p>
                        <p>{item?.maxQty}</p>
                      </div>
                    );
                  })}
              </MedBoxPicker>
            ) : (
              <Empty
                style={{ margin: "10vh 0" }}
                description="No Batches found"
              />
            )}
            <Modal
              title="Medicine Issue ?"
              visible={this.state.medIssueModal}
              onOk={() => this.saveMissingMeds()}
              onCancel={() => this.setState({ medIssueModal: false })}
              className="medIssueModal"
              okText="Submit"
              // okButtonProps={{
              //   disabled: this.checkForQty(this.state.selectedMed) ? false : true,
              // }}
            >
              <MedIssueModalWrapperPicker>
                <div>
                  {this.state.selectedMed?.productCode ? (
                    <MedBoxModalPicker>
                      <div className="medName">
                        {this.state.selectedMed?.name}
                      </div>

                      <div className="batchList">
                        <p>QTY</p>

                        <p>{this.state.selectedMed?.qty}</p>
                        {this.state.selectedMed?.qtyData?.length > 0 &&
                          this.state.selectedMed.qtyData.map((q, pos) => (
                            <>
                              <p>
                                {this.state.missingFlowReasons?.length > 0 && (
                                  <Select
                                    name="missingMed"
                                    defaultValue={{ value: 76 }}
                                    style={{ width: "100%" }}
                                    value={q.reasonId}
                                    onChange={(e) =>
                                      this.handleReasonChange(e, pos)
                                    }
                                    placeholder="Select a reason"
                                  >
                                    {this.state.missingFlowReasons.map(
                                      (i, p) => (
                                        <Option value={i.reasonId} key={p}>
                                          {i.value}
                                        </Option>
                                      )
                                    )}
                                  </Select>
                                )}
                              </p>

                              <p>
                                <IncrementDecrementInput
                                  disabled={!q.reasonId}
                                  min={0}
                                  max={this.state.selectedMed?.qty}
                                  value={q.qty}
                                  step={1}
                                  handleChange={(e) => {
                                    this.handleBatchEdit(e, pos);
                                  }}
                                />
                              </p>
                            </>
                          ))}
                        {this.state.remainingQty &&
                        this.state.selectedMed?.qty > 1 ? (
                          <p
                            className="addNewReason"
                            onClick={this.addNewReason}
                          >
                            Add New Reason
                          </p>
                        ) : null}
                      </div>
                    </MedBoxModalPicker>
                  ) : (
                    <Empty
                      style={{ margin: "5vh 0" }}
                      description="No Medicine found"
                    />
                  )}
                </div>

                <Divider>Or</Divider>

                <button
                  className="bbtn"
                  disabled={this.props.isLoading}
                  onClick={() => this.setState({ coldChainConfirmModal: true })}
                >
                  <GiThermometerCold /> Cold Chain
                </button>
              </MedIssueModalWrapperPicker>
            </Modal>

            <Modal
              title={`Mark Order ID : ${this.state.currentOrderId} as cold chain ?`}
              visible={this.state.coldChainConfirmModal}
              // centered
              onOk={this.markOrderColdChain}
              onCancel={() => this.setState({ coldChainConfirmModal: false })}
            />

            <FooterButtons>
              <button
                className="bbtn"
                disabled={this.props.isLoading}
                onClick={() => {
                  // this.state.selectedMed?.batches?.map((i, p) => {
                  //   this.handleBatchEdit(0, p);
                  // });
                  this.setState({ medIssueModal: true });
                }}
              >
                <RiErrorWarningLine /> Issue
              </button>

              <button
                className="bbtn"
                onClick={() => this.handlePicked()}
                disabled={
                  this.state.missingMedData?.length > 0 || this.props.isLoading
                }
              >
                Pick
                {/* ({" "}
              {`${this.state.updatedMedData.length + 1} / ${
                this.state.medData.length
              }`}{" "}
              ) */}
              </button>
            </FooterButtons>
          </Spin>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  pickerDetails: state.pickerorderReducer,
  onlineCheck:
    state.onlineStatusReducer?.isUserOnine?.response?.availableStatus?.value,
  pdf: state.packageTrackerReducer,
  newPickerDetails: state.newPickerOrderReducer,
  isLoading: state.LoaderReducer?.isLoading,
  pickerLog: state.MedicineLogReducer?.pickerLog,
  checkerDetails: state.newCheckerOrderReducer,
});

export default withRouter(
  connect(mapStateToProps, {
    pickerOrderDetailsThunk,
    updatePackageStatusThunk,
    saveMissingMedicineDetails,
    clearPickerDetails,
    getScannedPickerOrderDetailsThunk,
    savePickerMissingMedicineDetails,
    addToPickerLog,
    getMedDetailsThunk,
    getOrderItembatchesFromNetsuitThunk,
  })(PickerOrderPage)
);
